import React, { JSX } from "react";
import { Box } from "@mui/material";
import Typography from "@mui/material/Typography";

const SummaryItemRow = ({
  label,
  value,
  jsxValue
}: {
  label: string;
  jsxValue?: React.ReactNode;
  value?: string | number;
}): JSX.Element | null => {
  if (!value && !jsxValue) {
    return null;
  }
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        maxWidth: "400px"
      }}
    >
      <Typography>{label}</Typography>
      {jsxValue}
      {value && <Typography>{value}</Typography>}
    </Box>
  );
};

export default SummaryItemRow;
